import React from 'react';
import LoadingOverlay from "../../core/ui/LoadingOverlay";
var LoadingComponent = function LoadingComponent() {
  return /*#__PURE__*/React.createElement("div", {
    className: "-loading -active"
  }, /*#__PURE__*/React.createElement("div", {
    className: "-loading-inner"
  }, /*#__PURE__*/React.createElement(LoadingOverlay, null)));
};
export default LoadingComponent;